import {
  createInjectionToken,
  createNoopInjectionToken,
} from 'ngxtension/create-injection-token';
import { FintocOptions } from './fintoc.model';

export const [
  injectFintocPublicKey,
  provideFintocPublicKey,
  FINTOC_PUBLIC_KEY,
] = createNoopInjectionToken<string>('Fintoc Public Key');

export const [injectFintocScriptUrl] = createInjectionToken(
  () => 'https://js.fintoc.com/v1',
);

export const [injectFintoButtonBrandUrl] = createInjectionToken(
  () => 'https://assets.fintoc.com/?img_name=combo_mx_dark',
);

export const [injectFintocDefaultOptions] = createInjectionToken(
  (publicKey: string): FintocOptions => ({
    holderType: 'individual',
    country: 'mx',
    product: 'payments',
    publicKey,
    sessionToken: '',
    widgetToken: '',
  }),
  { deps: [FINTOC_PUBLIC_KEY] },
);
